import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
    <path d="M11.229 14.685l-3.908-3.852C6.635 10.157 7.121 9 8.092 9h7.816c.971 0 1.457 1.157.771 1.834l-3.908 3.852a1.1 1.1 0 0 1-1.541 0z" />
  </svg>
);
